import { useQuery } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { useUserToken } from "@/context/auth-context";
import { OrganizationRole } from "@/types/organization-roles";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

export const useOrganizationRoles = () => {
  const userToken = useUserToken();
  return useQuery(
    [ENDPOINTS.organization_roles],
    async (): Promise<OrganizationRole[]> =>
      fetch(`${ENDPOINTS.organization_roles}`, {
        method: "GET",
        headers: jsonAuthHeaders(userToken),
      }).then(handleResponse),
  );
};
